import { Controller } from '@hotwired/stimulus';

import BulletChart, { BulletChartOptions, BulletChartSection } from '../graphs/bullet-chart';

export default class extends Controller {
  static targets = ['svg'];

  svgTarget: SVGElement;

  resizeListener: () => void;

  connect() {
    this.draw();
    this.connectResizeListener();
  }

  disconnect() {
    this.disconnectResizeListener();
  }

  draw() {
    const chart = new BulletChart(this.svgTarget, this.graphOptions);
    chart.draw();
  }

  connectResizeListener() {
    this.resizeListener = this.draw.bind(this);
    window.addEventListener('resize', this.resizeListener);
  }

  disconnectResizeListener() {
    window.removeEventListener('resize', this.resizeListener);
  }

  get graphOptions(): BulletChartOptions {
    return {
      minLabel: this.data.get('min-label') || '',
      maxLabel: this.data.get('max-label') || '',
      measure: parseFloat(this.data.get('measure')!),
      sections: JSON.parse(this.data.get('sections') || '[]') as BulletChartSection[],
      status: this.data.get('status') || '',
    };
  }
}
